import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/* Everything you've been tagged in, newest first. Opening the list marks them
   read; "Remove my tag" takes your name off that post or comment. */
export default function MentionsList({ notify, onOpenPost }) {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.mentions().then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items || items.length === 0) return null;
  const unread = items.filter((i) => i.unread).length;

  function toggle() {
    setOpen(!open);
    if (!open && unread) api.markMentionsRead().then(() => setItems(items.map((i) => ({ ...i, unread: false })))).catch(() => {});
  }

  return (
    <section className="card pad mentions">
      <button className="linklike mentions-head" onClick={toggle} aria-expanded={open}>
        <b>Mentions</b> {unread > 0 && <em className="ad-badge">{unread} new</em>}
        <span className="muted-sm">{open ? 'hide' : `${items.length}`}</span>
      </button>
      {open && items.map((m) => (
        <div key={m.id} className={`invite-item${m.unread ? ' unread' : ''}`}>
          <div className="invite-main">
            <b>{m.by}</b>
            <span className="muted-sm">“{m.snippet}” · in {m.post_title || 'a post'}</span>
          </div>
          {onOpenPost && <button className="btn quiet sm" onClick={() => onOpenPost(m.post_id)}>Open</button>}
          <button className="btn quiet sm"
            onClick={() => window.confirm('Remove your name from this post?')
              && api.removeMention(m.id).then(() => { notify?.('Your tag was removed'); load(); }).catch((e) => notify?.(e.message))}>
            Remove my tag
          </button>
        </div>
      ))}
    </section>
  );
}
